import Avatar from '../../../../../avatar/Avatar';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import DraggableList from '../../../../../Draggable/DraggableList/DraggableList';
import Typography from '@mui/material/Typography';
import ReviewerUsersSkeleton from '../ReviewerUsersSkeleton';
import Chip from '@mui/material/Chip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import './ReviewerUsersPanel.css';

const ReviewerUsersPanel = ({
  users = [],
  setSelectedUserIds,
  selectedUserIds = [],
  isLoadingUsers = false,
  userInputSearch = ''
}) => {
  const [isMounted, setIsMounted] = useState(false);

  const draggableUsers = users
    ?.filter((item) => item?.display)
    ?.map((item, index) => {
      const isSelected = selectedUserIds?.includes(item?.code);
      const roles = item?.roles || [];
      return {
        id: index,
        itemId: item?.id,
        isSelected,
        content: (
          <ListItem
            onClick={(e) => handleClick(e, item?.code)}
            sx={{
              cursor: 'pointer',
              width: 'auto'
            }}
          >
            <FontAwesomeIcon icon='fa-solid fa-grip-dots-vertical' style={{ marginRight: '1rem' }} />
            <ListItemAvatar>
              <Avatar size='small' variant='circular' alt={item?.code} src={`photos/${item?.photo}`} />
            </ListItemAvatar>
            <ListItemText
              primary={`${item.firstName} ${item.lastName}`}
              secondary={
                <div
                  className='flex flex-wrap items-center gap-2 overflow-hidden'
                  style={{ maxWidth: '100%' }}
                >
                  <span style={{ fontSize: '10px' }}>{item?.code}</span>{' '}
                  {roles?.map((role) => {
                    const label = typeof role === 'string' ? role : role?.name;
                    return <Chip key={label} label={label} size='small' sx={{ margin: '2px' }} />;
                  })}
                </div>
              }
            />
            <Checkbox id={`checkbox-id-user-${item.code}`} checked={isSelected} color='primary' />
          </ListItem>
        )
      };
    });

  const handleClick = (e, code) => {
    setSelectedUserIds((prev) => (prev.includes(code) ? prev.filter((i) => i !== code) : [...prev, code]));
  };

  //On react 18 we need to load Droppable element after the component is mounted otherwise it won't work
  //See: https://github.com/atlassian/react-beautiful-dnd/issues/2399
  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#fff',
        height: 'calc(100vh - 143px)'
      }}
    >
      {isLoadingUsers && <ReviewerUsersSkeleton />}
      {!isLoadingUsers && isMounted && draggableUsers.length > 0 && draggableUsers ? (
        <Droppable droppableId='DRAGGABLE_USERS_LIST' isDropDisabled={true}>
          {(provided, snapshot) => {
            return (
              <div>
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className='reviewers-panel__droppable-list'
                >
                  <DraggableList items={draggableUsers} selectedElements={selectedUserIds} />
                  {provided.placeholder}
                </div>
              </div>
            );
          }}
        </Droppable>
      ) : (
        <>
          {!isLoadingUsers && (
            <Box className='reviewers-panel__no-data'>
              <FontAwesomeIcon icon='fa-solid fa-user-magnifying-glass' size='3x' color='#80808094' />{' '}
              <Typography variant='body1' gutterBottom sx={{ fontSize: '14px' }}>
                {userInputSearch?.trim() !== '' && draggableUsers.length === 0
                  ? `No users found for "${userInputSearch}"`
                  : 'You do not have any users yet'}
              </Typography>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default ReviewerUsersPanel;
